import { DatePicker } from 'antd';
import { DatePickerProps } from 'antd/lib/date-picker';
import * as React from 'react';

const Component: React.FunctionComponent<DatePickerProps> = props => <DatePicker {...props} />;

export default Component;
